export const CTA_HREF: string = '/collections/experiences';

export enum ImpactCTATestIds {
    HOST = 'ImpactCTA',
    CTA_LINK = 'ImpactCTA__link',
}
